import script from "./EpkChapterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EpkChapterPage.vue?vue&type=script&setup=true&lang=js"

import "./EpkChapterPage.vue?vue&type=style&index=0&id=38b6a867&lang=scss"

const __exports__ = script;

export default __exports__